import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Div, MarketingButton } from 'common/styles/oc-styled-components';
import { updateLoginError } from 'connect/actions';
import { selectDataLoginFormError } from 'connect/selectors';

import { StyledAlert } from '../../../checkout-styled-components';

// TODO: Delete this step after the last member ID reminder magic link has expired
/*
  We don't need this step anymore, but users may still come back from the magic link, so we need to wait until they've expired/been used
  We should also remove any references to UTM_SOURCES, and do a regex search for /member.*id.*reminder/ and /.*member.*id/ to make sure we're not using it anywhere else
*/
export const ReturnError = ({ state, close }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginError = useSelector(selectDataLoginFormError);
  const [isSlotValid, setIsSlotValid] = useState();
  const { clinic, requestedAppointment } = state;

  useEffect(() => {
    if (!clinic.slots?.length) {
      return;
    }

    setIsSlotValid(
      clinic.slots?.some((slot) => slot.id === requestedAppointment.slotId),
    );
  }, [clinic, requestedAppointment]);

  // If there are no errors, fall back to profile page
  useEffect(() => {
    if (isSlotValid === true || !loginError) {
      goToProfile();
    }
  }, [isSlotValid, loginError]);

  // Clear errors on unload (navigate away or close modal)
  useEffect(
    () => () => {
      dispatch(updateLoginError(null));
    },
    [dispatch],
  );

  const isAuthTokenInvalid = loginError?.includes('Auth token is not valid.');

  const goToLogin = () => {
    history.push(`/results/${clinic.id}/checkout/patient`);
  };

  const goToProfile = () => {
    close();
  };

  return (
    <div>
      <h3>Sorry, something went wrong</h3>
      {isAuthTokenInvalid
      && (
        <Div margin="0 0 30px">
          <StyledAlert
            height="auto"
            margin="0 0 20px"
            message="This link has expired, please login with your username and password. You may request a password reset if you have not set one."
          />
          <MarketingButton
            type="primary"
            shape="round"
            size="large"
            block
            htmlType="button"
            disabled={!clinic.id}
            loading={!clinic.id}
            onClick={goToLogin}
          >
            Login
          </MarketingButton>
        </Div>
      )}
      {isSlotValid === false
      && (
        <Div>
          <StyledAlert
            height="auto"
            margin="0 0 20px"
            message="Unfortunately, the slot you were trying to book has been taken or has expired. Feel free to look at other available slots."
          />
          <MarketingButton
            type="primary"
            shape="round"
            size="large"
            block
            htmlType="button"
            disabled={!clinic.id}
            loading={!clinic.id}
            onClick={goToProfile}
          >
            View Slots
          </MarketingButton>
        </Div>
      )}
    </div>
  );
};

ReturnError.propTypes = {
  state: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
};
